import axios from "axios";
import AppContext from "../Context/Context";

const axiosAuth = axios.create();

//we intercept every requests
axiosAuth.interceptors.request.use(
  async function (config: any) {
    //anything you want to attach to the requests such as token
    // var token = AppContext.GetCookie("Token");
    // var sntkn = AppContext.GetCookie("sntkn");
    // if (token && token !== "" && !AppContext.IsJwtExpired(token)) {
    //   config.headers.Authorization = "Bearer " + token;
    //   config.headers.sntkn = sntkn;
    // } else {
    //   await AppContext.GetNewJWTTokenFromRefreshToken(true);
    //   token = AppContext.GetCookie("Token");
    //   config.headers.Authorization = "Bearer " + token;
    //   config.headers.sntkn = sntkn;
    // }

    config.withCredentials = true;
    const Local_Token = process.env.REACT_APP_Local_Token;
    if (Local_Token && Local_Token !== "") {
      config.headers.Authorization = "Bearer " + Local_Token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//we intercept every response
axiosAuth.interceptors.response.use(
  async function (response) {
    return response;
  },
  (error) => {
    //check for authentication or anything like that
    if (error.response.status === 401) {
      // window.location = AppContext.WebAppLink  as any;
    }
    return Promise.reject(error);
  }
);

export default axiosAuth;
